
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AuthService from "../../services/auth.service";
import * as MyStorage from "../../helpers/myStorage";

export const loginAsync = createAsyncThunk(
  "user/login",
  async (credentials, { rejectWithValue }) => {
    try {
      const res = await AuthService.doLogin({
        login: credentials.login,
        passwordPlain: credentials.password,
        connectionCode: credentials.connectionCode ?? "PARTNER",
      });

      const data = res?.data || {};
      const jwt = data.jwt;
      if (!jwt) return rejectWithValue("Login response missing token");
      const connectionList = Array.isArray(data.connectionList) ? data.connectionList : [];
      const nodeList = connectionList[0]?.nodeList || [];

      // Persist
      if (nodeList.length) MyStorage.setNodeList(nodeList);
      MyStorage.setToken(jwt);
      MyStorage.setCode(credentials.connectionCode ?? "PARTNER");

      // Token decode (senin helper’ın)
      const { exp, user } = MyStorage.getTokenInfo();

      return {
        token: jwt,
        expireIn: exp,
        user: { ...user, connectionCode: credentials.connectionCode ?? "PARTNER" },
      };
    } catch (e) {
      const code = e?.response?.data?.error?.code;
      const msg = e?.response?.data?.error?.message;
      if (code === 1302) return rejectWithValue("User Not Found");
      if (code === 1301) return rejectWithValue("Username or password is incorrect");
      if (code === 5002) return rejectWithValue("Record not found!");
      return rejectWithValue(msg || e?.message || "Login failed");
    }
  }
);

export const logoutAsync = createAsyncThunk(
  "user/logout",
  async (isSessionExpired = null) => {
    try {
      //await AuthService.doLogout();
      MyStorage.removeToken();
    } catch (err) {
      //
    }
    return isSessionExpired;
  }
);

const { token, user, exp } = MyStorage.getTokenInfo();
const initialState = {
  loading: false,
  isLoggedIn: user && Object.keys(user).length !== 0 && MyStorage.getNode(),
  userInfo: user,
  accessToken: token,
  expireIn: exp,
  sessionExpired: true,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginError(state, action) {
      state.error = action.payload;
    },
    removeError(state) {
      state.error = null;
    },
    setExpired(state, action) {
      state.sessionExpired = action.payload || false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state) => {
        state.loading = true;
        state.error = null;  //ekledim
      })
      .addCase(loginAsync.fulfilled, (state, action) => {
        let { token, user, expireIn } = action.payload;
        state.loading = false;
        // state.isLoggedIn = true;
        state.userInfo = user;
        state.accessToken = token;
        state.expireIn = expireIn;
        state.sessionExpired = null;
      })
      .addCase(loginAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logoutAsync.fulfilled, (state, action) => {
        state.isLoggedIn = false;
        state.userInfo = {};
        state.accessToken = null;
        state.expireIn = 0;
        state.sessionExpired = action.payload;
      });
  },
});

export const { loginError, removeError, setExpired } = authSlice.actions;
export default authSlice.reducer;

